import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getCheckout, submitPayment, saveNoPaymentRegistration, } from "../../api/checkout";
import { getApplicationSettings, getInternationalCountries, getInternationalStates, getInternationalPreferredCountries } from "../../api/applicationSettings";
import * as accountActions from "../../actions/accountActions";
import React, { PureComponent } from "react";
import Page from "../Page";
import Box from "../Box";
import * as config from "../../config";
import ProofOfStudiesUpload from "../ProofOfStudiesUpload";
import LoadingButton from "../LoadingButton";
import LoadingContent from "../LoadingContent";
import { toast } from "react-toastify";
import * as util from "../../lib/util";
import MemberSavings from "../MemberSavings";
import ReactPixelCompletion from "react-facebook-pixel";
import "postal-codes-js";

const errStrings = {
  error: "error",
  required: "This field is required",
};

const input = {
  firstName: "firstName",
  lastName: "lastName",
  cardType: "cardType",
  cardNumber: "cardNumber",
  expMonth: "expMonth",
  expYear: "expYear",
  securityCode: "securityCode",
  street1: "street1",
  city: "city",
  state: "state",
  zip: "zip",
  country: "country",
  county: "county",
};

const defaultStaffPayment = {
  paymentType: "",
  amount: "",
  checkNumber: "",
  cardHolderName: "",
  notes: "",
};

class CheckoutPage extends PureComponent {
  static propTypes = {
    history: PropTypes.object.isRequired,
    registrationMembershipType: PropTypes.string,
    joinRenewMembershipType: PropTypes.string,
    registrationMethod: PropTypes.string,
    me: PropTypes.object.isRequired,
    getMe: PropTypes.func.isRequired,
  };

  constructor(props) {

    console.log("constructor");

    super(props);
    
    this.state = {
      payment: {
        promoCode: localStorage.getItem(config.storageKeys.promoCode),
        registrationMembershipType: this.props.registrationMembershipType,
        joinRenewMembershipType: this.props.joinRenewMembershipType,
        firstName: "",
        lastName: "",
        cardType: "",
        cardNumber: "",
        expMonth: "",
        expYear: "",
        securityCode: "",
        street1: "",
        street2: "",
        street3: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        county: "",
        isEarlyReg: false,
        staffPayments: [],
      },
      staffPayment: { ...defaultStaffPayment },
      showAddStaffPayment: false,      
      checkoutResult: null,
      loadingPrerequisites: true,
      loading: true,
      isLoading: false,
      validation: {},
      validationSummaryToastId: null,
      applicationSettings: [{}],
      internationalCountries: [{}],
      internationalCountriesWithStates: [],
      internationalCountryCodes: [],
      internationalStates: [{}],
      showInternationalRegionTerritory: false,
      showState: true,      
    };

    this.ref_contactCountry = React.createRef();
    this.ref_contactPostalCode = React.createRef();
  }

  componentDidMount = () => {

     console.log("componentDidMount");

    this._getCheckout();    

    const { me } = this.props;

    if(me.event.conferenceType === "HealthPolicy") {
      if (me.person.preferredMailingAddress === "Home Address" && me.person.line1 !== null) {
        this._setAddressHp(me.person);
      } else if (me.person.preferredMailingAddress === "Business Address" && me.person.line1 !== null) {
        this._setAddressHp(me.person);
      }
    } else {
      if (me.person.preferredMailingAddress === "Home Address" && me.person.homeAddress) {
        this._setAddress(me.person.homeAddress);
      } else if (me.person.preferredMailingAddress === "Business Address" && me.person.businessAddress) {
        this._setAddress(me.person.businessAddress);
      }      
    }

    if (config.facebookPixelTrackingId) {
      const facebookPixeloptions = {
        autoConfig: true,
        debug: true,
      };

      ReactPixelCompletion.init(
        config.facebookPixelTrackingId,
        {},
        facebookPixeloptions
      );
    }
 };

  _setAddress = (address) => {

    console.log("_setAddress");
    debugger

    this.setState((prevState) => ({
      ...prevState,
      payment: {
        ...prevState.payment,
        street1: address.line1,
        street2: address.line2,
        street3: address.Line3,
        city: address.city,
        state: address.state,
        zip: address.postalCode,
        country: address.country,
        county: address.county,
      },
    }));
  };

  _setAddressHp = (person) => {

    console.log("_setAddress");
    debugger

    this.setState((prevState) => ({
      ...prevState,
      payment: {
        ...prevState.payment,
        street1: person.line1,
        street2: person.line2,
        street3: person.line3,
        city: person.city,
        state: person.stateProvince,
        zip: person.postalCode,
        country: person.country,
        county: person.county,
      },
    }));
  };

   _getCheckout = () => {

    console.log("_getCheckout");

    let registrationMembershipType = this.props.registrationMembershipType;
    debugger
    if (!this.props.me.person.isMember || this.props.me.person.isMember == "No") {
      console.log("Join/Renew Memberhip Type: " + this.props.joinRenewMembershipType);
      if (!registrationMembershipType && this.props.joinRenewMembershipType) {
        registrationMembershipType = this.props.joinRenewMembershipType;
      } else {             
        registrationMembershipType = "NP Member";
      }
    }    

    getCheckout(
      registrationMembershipType,
      this.state.payment.isEarlyReg,
      this.props.joinRenewMembershipType,
      localStorage.getItem(config.storageKeys.promoCode)
    ).then((response) => {

      const states = ["United States", "Canada", "Australia"];
      this.setState({ internationalCountriesWithStates: states });

      console.log("this.state.payment.country: " + this.state.payment.country);

      if(this.state.internationalCountriesWithStates.includes(this.state.payment.country)) {     
        
        console.log("showInternationalRegionTerritory: false");
        console.log("showState: true");

        this.setState({ showInternationalRegionTerritory: false});
        this.setState({ showState: true});

        this._getInternationalStates(this.state.payment.country);

      } else {

        console.log("showInternationalRegionTerritory: true");
        console.log("showState: false");

        this.setState({ showInternationalRegionTerritory: true});
        this.setState({ showState: false});        
      }

      const { staffPayments } = this.state.payment;
      const { total } = response.conferenceFees;
      const paymentAmount = staffPayments.reduce((prev, cur) => {
        return prev + parseFloat(cur.amount);
      }, 0);

      const firstCheckout = !this.props.isRegistered;

      const totalDueOnCard = total - paymentAmount;
      if (
        response.conferenceFees.total === 0 &&
        response.conferenceFees &&
        response.conferenceFees.eventDiscountTotal >= response.conferenceFees.eventFee && 
        response.conferenceFees.totalWorkshopFees === 0 &&
        totalDueOnCard === 0
      ) {        
        saveNoPaymentRegistration().then((paymentResponse) => {
          this.setState({
            isLoading: false,
          });

          if (paymentResponse.success) {
            if (config.facebookPixelTrackingId && firstCheckout) {
              ReactPixelCompletion.fbq("track", "CompleteRegistration");
            }

            localStorage.clear();
            window.location.href =
              "/registration-complete?paymentProcessed=true";
          }
        });
      } else {        
        this.setState({
          checkout: response,
          loading: false,
        });        
      }

      console.log("call api methods");

      this._getApplicationSettings();
      this._getInternationalCountries(); 
      this._getInternationalPreferredCountries();         
      this._getInternationalStates(this.state.payment.country);
    });
  };

  _getApplicationSettings = () => {

    console.log("_getApplicationSettings");

    this.setState({ loadingPrerequisites: true });    
    getApplicationSettings().then((response) => {
      this.setState({ applicationSettings: JSON.parse(response), loadingPrerequisites: false });
    })    
  }

  _getInternationalStates = (countryName) =>
  {
    console.log("_getInternationalStates");
    console.log("_getInternationalStates.countryName: " + countryName);

      getInternationalStates(countryName).then((response) => {
        this.setState({ internationalStates: response });      
    })
  }

  _getInternationalCountries = () => {
    
    console.log("_getInternationalCountries");

    this.setState({ loadingPrerequisites: true });
    getInternationalCountries().then((response) => {  
      this.setState({ internationalCountryCodes: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

  _getInternationalPreferredCountries = () => {

    console.log("_getInternationalPreferredCountries");

    this.setState({ loadingPrerequisites: true });
    getInternationalPreferredCountries().then((response) => {
      this.setState({ internationalPreferredCountries: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

  _updatePaymentInfo = (e) => {

    console.log("_updatePaymentInfo");

    let { payment } = this.state;

    const target = e.target;
    const name = e.target.name;
    let value = e.target.value;

    const validation = { ...this.state.validation };

    delete validation[name];

    if (name === "cardNumber") {
      value = value.replace(/\D/g, "");
    } else if (name === "securityCode") {
      value = value.replace(/\D/g, "");
    }

    if(name === "country") {
      
      console.log("target.name: country");

      payment.country = target.value;
      
      console.log("payment.country: " + target.value);

      if(this.state.internationalCountriesWithStates.includes(target.value)) {     
        
        console.log("showInternationalRegionTerritory: false");
        console.log("showState: true");

        this.setState({ showInternationalRegionTerritory: false});
        this.setState({ showState: true});

        this._getInternationalStates(target.value);

      } else {

        console.log("showInternationalRegionTerritory: true");
        console.log("showState: false");

        this.setState({ showInternationalRegionTerritory: true});
        this.setState({ showState: false});        
      }      
    }

    if (typeof e.target.checked !== "undefined" && e.target.type === "checkbox") {
      value = target.checked;
    }

    payment[name] = value;

    this.setState((prevState) => ({
      ...prevState,
      validation,
      payment: {
        ...prevState.payment,
      },
    }));

    if (typeof e.target.checked !== "undefined" && e.target.type === "checkbox") {
      this._getCheckout();
    }
  };

  _isValidPostalCode(iso2, value) {
    console.log("_isValidPostalCode");
    const postalCodes = require('postal-codes-js');
    return postalCodes.validate(iso2, value);
  }

  _validForm = () => {

    console.log("_validForm");

    const validation = {};
    let { payment } = this.state;

    if (this._totalDueOnCard() <= 0) {
      let toastId = this.state.validationSummaryToastId;
      if (toastId) {
        toast.dismiss(toastId);
        this.setState({ validationSummaryToastId: null });
      }

      this.setState({ validation: {} });
      return true;
    }   

    Object.keys(payment).forEach((stateKey) => {

      console.log("stateKey: " + stateKey);

      if (stateKey === input.country && !payment.country) {
        console.log(stateKey + " failed validation");
        validation[input.country] = { state: errStrings.error, helpBlock: errStrings.required };
      } 
      
      if(stateKey === input.state && (this.state.internationalCountriesWithStates.includes(payment.country) && payment[input.state] === "")) {
        console.log(stateKey + " failed validation");
        console.log("payment.country: " + payment.country);
        console.log("this.state.internationalCountriesWithStates.includes(payment.country): " + this.state.internationalCountriesWithStates.includes(payment.country));        
        console.log("payment[input.state]: " + payment[input.state]);
        validation[input.state] = { state: errStrings.error, helpBlock: errStrings.required };        
      }

      if (stateKey.zip) {
        let country = this.state.internationalCountries.filter(obj => {
          return obj.countryName === this.ref_contactCountry.current.value
        })

        let result = this._isValidPostalCode(country[0].iso2, this.ref_contactPostalCode.current.value);

        if(result !== "true") {
          console.log(stateKey + " failed validation: " + result);           
          validation[input.zip] = { state: errStrings.error, helpBlock: "" };              
          toast.error("Postal code " + (this.ref_contactPostalCode.current.value === "" ? "blank" : this.ref_contactPostalCode.current.value) + " is not valid for country " + this.ref_contactCountry.current.value + ".", {autoClose: 10000});
        }
      
      } else {        
        if (input[stateKey]) {

          let bypassValidation = false;

          // state. validation handled above
          if(input[stateKey] === input.state) {
            // ignore
            bypassValidation = true;
          }
          
          // county. validation handled above
          if(input[stateKey] === input.county) {
            // ignore
            bypassValidation = true;
          }

            console.log("bypassValidation: " + bypassValidation);

          // else
          if (bypassValidation === false && !payment[stateKey]) {       
            console.log("failed validation: " + stateKey);     
            validation[stateKey] = { state: errStrings.error, helpBlock: errStrings.required };
          }
        }
      }
    });

    this.setState({ validation }, () => {
      let toastId = this.state.validationSummaryToastId;
      if (Object.keys(validation).length > 0) {
        if (toastId) {
          toast.update(toastId, {
            render: this._toastValidationErrorMessage(),
            autoClose: false,
            onClose: () => {
              this.setState({ validationSummaryToastId: null });
            },
          });
        } else {
          toastId = toast.error(this._toastValidationErrorMessage(), {
            autoClose: false,
            onClose: () => {
              this.setState({ validationSummaryToastId: null });
            },
          });
        }

        this.setState({ validationSummaryToastId: toastId });
      } else {
        if (toastId) {
          toast.dismiss(toastId);
          this.setState({ validationSummaryToastId: null });
        }
      }
    });

    return !Object.keys(validation).length;
  };

  _toastValidationErrorMessage = () => {
    
    console.log("_toastValidationErrorMessage");

    const { validation } = this.state;
    return (
      <div className="validation-summary">
        <div className="text-bold header">
          Please correct the following validation errors:
        </div>
        <ul>
          {Object.keys(validation).map((stateKey, index) => (
            <li key={index}>
              {util.properCase(util.unCamelCase(stateKey))} is required.
            </li>
          ))}
        </ul>
      </div>
    );
  };

  _submitPayment = (e) => {

    console.log("_submitPayment");

    if (e) {
      e.preventDefault();
    }

    if (this._validForm()) {
      let { payment } = this.state;

      this.setState({
        isLoading: true,
      });

      toast("Processing payment...");

      submitPayment(payment)
        .then((response) => {
          if (response.success) {
            toast.success("Payment accepted!", {
              autoClose: true,
            });

            const firstCheckout = !this.props.isRegistered;

            if (config.facebookPixelTrackingId && firstCheckout) {
              ReactPixelCompletion.fbq("track", "CompleteRegistration");
            }

            localStorage.removeItem(config.storageKeys.promoCode);
            localStorage.removeItem(config.storageKeys.registrationMembershipType);
            localStorage.removeItem(config.storageKeys.registrationMethod);
            localStorage.removeItem(config.storageKeys.joinRenewMembershipType);
            localStorage.removeItem(config.storageKeys.isNp);

            this.props.getMe().then(() => {
              this.props.history.push("/registration-complete?paymentProcessed=true");
            });
          } else {
            if (response.message) {
              toast.error(response.message);
            } else {
              toast.error("An error occurred during the processing of your payment");
            }

            this.setState({
              checkoutResult: response,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          toast.error(
            "An error occurred during the processing of your payment"
          );
          this.setState({
            isLoading: false,
          });
        });
    }
  };

  _goToMembership = () => {

    console.log("_goToMembership");

    this.props.history.push({
      pathname: "/membership-type",
      state: { fromCheckout: true },
    });
  };

  _proofOfStudiesUploaded = () => {

    console.log("_proofOfStudiesUploaded");

    this.setState((prevState) => ({
      ...prevState,
      checkout: {
        ...prevState.checkout,
        showSubmitProofOfStudies: false,
      },
    }));
  };

  _removeStaffPayment = (index) => {

    console.log("_removeStaffPayment");

    let { staffPayments } = this.state.payment;
    staffPayments.splice(index, 1);
    this.setState((prevState) => ({
      ...prevState,
      payment: {
        ...prevState.payment,
        staffPayments,
      },
    }));
  };

  _updateStaffPayment = (e) => {

    console.log("_updateStaffPayment");

    let { staffPayment } = this.state;

    const target = e.target;
    const name = target.name;
    let value = target.value;

    if (name === "checkNumber") {
      value = value.replace(/\D/g, "");
    } else if (name === "amount") {
      value = value.replace(/[^0-9.-]+/g, "");
    }

    staffPayment[name] = value;
    this.setState(staffPayment);
  };

  _saveStaffPayment = () => {

    console.log("_saveStaffPayment");

    let { staffPayments } = this.state.payment;
    let { staffPayment } = this.state;

    staffPayments.push(staffPayment);

    this.setState((prevState) => ({
      ...prevState,
      payment: {
        ...prevState.payment,
        staffPayments,
      },
      showAddStaffPayment: false,
      staffPayment: { ...defaultStaffPayment },
    }));
  };

  _cancelStaffPayment = () => {

    console.log("_cancelStaffPayment");

    this.setState({
      showAddStaffPayment: false,
      staffPayment: { ...defaultStaffPayment },
    });
  };

  _totalDueOnCard = () => {

    console.log("_totalDueOnCard");

    const { staffPayments } = this.state.payment;
    const { total } = this.state.checkout.conferenceFees;
    const paymentAmount = staffPayments.reduce((prev, cur) => {
      return prev + parseFloat(cur.amount);
    }, 0);

    return total - paymentAmount;
  };

  _renderStaffPayment = () => {

    console.log("_renderStaffPayment");

    let { staffPayments } = this.state.payment;
    let { staffPayment } = this.state;

    if (this.props.me.isImpersonating && this.props.me.isStaff) {
      return (
        <Box title="Staff Payment">
          <div className="staff-payments">
            {staffPayments.length === 0 && !this.state.showAddStaffPayment && (
              <div className="empty">
                No payments exist for the current registration.
              </div>
            )}
            {staffPayments.length > 0 && (
              <div className="row header">
                <div className="col-lg-2 col-3">Type</div>
                <div className="col-lg-2 col-3">Check #</div>
                <div className="col-lg-2 col-3">Amount</div>
              </div>
            )}
            {staffPayments.map((payment, index) => (
              <div className="row payment-row" key={index}>
                <div className="col-lg-2 col-3">{payment.paymentType}</div>
                <div className="col-lg-2 col-3">{payment.checkNumber}</div>
                <div className="col-lg-2 col-3">
                  ${parseFloat(payment.amount).toFixed(2)}
                </div>
                <div className="col-3">
                  <button
                    className="link-button"
                    type="button"
                    onClick={(e) => this._removeStaffPayment(index)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
            {this.state.showAddStaffPayment && (
              <div className="add-payment">
                <div className="row">
                  <div className="col-lg-10 col-centered">
                    <div className="row">
                      <div className="col-lg-4">
                        <label>Method:</label>
                        <select
                          style={{ width: "auto" }}
                          name="paymentType"
                          value={
                            staffPayment.paymentType
                              ? staffPayment.paymentType
                              : ""
                          }
                          onChange={this._updateStaffPayment}
                        >
                          <option />
                          <option>Cash</option>
                          <option>Check</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4">
                        <label>Amount:</label>
                        <input
                          type="text"
                          style={{ width: "80px" }}
                          name="amount"
                          value={staffPayment.amount}
                          onChange={this._updateStaffPayment}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4">
                        <label>Check #:</label>
                        <input
                          type="text"
                          style={{ width: "120px" }}
                          name="checkNumber"
                          value={staffPayment.checkNumber}
                          onChange={this._updateStaffPayment}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <label>Payor Name:</label>
                        <input
                          type="text"
                          style={{ width: "240px" }}
                          name="cardHolderName"
                          value={staffPayment.cardHolderName}
                          onChange={this._updateStaffPayment}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8">
                        <label>Notes:</label>
                        <textarea
                          style={{ width: "240px" }}
                          name="notes"
                          value={staffPayment.notes}
                          onChange={this._updateStaffPayment}
                        />
                      </div>
                    </div>
                    <div className="row ml-lg-4 pl-lg-1">
                      <div className="col-lg-3 col-6 ml-lg-5 pr-0">
                        <button
                          className="btn btn-primary btn-block"
                          type="button"
                          onClick={(e) => this._saveStaffPayment()}
                        >
                          Save
                        </button>
                      </div>
                      <div className="col-lg-3 col-6 pl-2">
                        <button
                          className="btn btn-secondary btn-block"
                          type="button"
                          onClick={(e) => this._cancelStaffPayment()}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="mt-3">
              {!this.state.showAddStaffPayment && (
                <div>
                  <button
                    className="link-button float-right btn-add-payment"
                    type="button"
                    onClick={() => this.setState({ showAddStaffPayment: true })}
                  >
                    Add Payment
                  </button>
                </div>
              )}
              <div>
                <input
                  type="checkbox"
                  id="isEarlyReg"
                  checked={!!this.state.payment.isEarlyReg}
                  name="isEarlyReg"
                  onChange={this._updatePaymentInfo}
                />
                <label htmlFor="isEarlyReg"> Receives Early Rate</label>
              </div>
            </div>
          </div>
          {staffPayments.length > 0 && (
            <div className="remaining-balance">
              <span className="text-bold">Remaining Balance:</span> $
              {this._totalDueOnCard().toFixed(2)}
            </div>
          )}
        </Box>
      );
    } else {
      return null;
    }
  };

  render() {

    if (this.state.loading) {
      return <LoadingContent />;
    } 

    let { checkout, validation, checkoutResult, payment } = this.state;
    let { conferenceFees } = this.state.checkout;
    let { person } = checkout;
    let { me, joinRenewMembershipType } = this.props;

    const hasEventDiscount = checkout.membership && checkout.membership.hasEventDiscount;
    const { membershipStatus } = this.props.me;
    const isNonMember = (membershipStatus === 0 || membershipStatus === 3) && !me.person.isMember;
    const showJoinOrRenew =
      !me.isRegistered &&
      me.membershipStatus !== 1 &&
      me.membershipStatus !== 2 &&
      me.availableMembershipTypes.filter((m) => !m.disabledForUser).length > 0 && joinRenewMembershipType === "" && !hasEventDiscount;
    const isEligibleForRenewal = checkout.person.isMember && showJoinOrRenew;

    let years = [];

    const currentYear = new Date().getFullYear();

    for (var i = 0; i < 12; i++) {
      years.push(currentYear + i);
    }

    return (
      <Page
        showHeader={false}
        title="Please Enter Your Credit Card Information"
      >
        <form>
          {this.props.registrationMethod === "quick" &&
            me.event.sessionSelection && (
              <div className="warning-box p-4 mt-3">
                <div className="text-bold mb-2">
                  Don't forget! Session Selection Occurs After Payment
                </div>
                <div>
                  After payment, you are able to add sessions to your schedule.
                  Select your sessions early to save your spot.
                </div>
              </div>
            )}
{/*             <Box title="Registrant Information">
            <div className="d-lg-none">
              {person.additionalInfo.workingOrVolunteeringAsNP && (
                <div className="">
                  <div>Are you currently working or volunteering as an NP?</div>
                  <div className="registration-info">
                    {person.additionalInfo.workingOrVolunteeringAsNP}
                  </div>
                  <div className="divider" />
                </div>
              )}
              {person.additionalInfo.nonNPJobProfession &&
                person.additionalInfo.nonNPJobProfession !== "Select One" && (
                  <div className="">
                    <div>Working as:</div>
                    <div className="registration-info">
                      {person.additionalInfo.nonNPJobProfession}
                    </div>
                    <div className="divider" />
                  </div>
                )}
              {checkout.showSubmitProofOfStudies && (
                <div>
                  <ProofOfStudiesUpload
                    onUploaded={this._proofOfStudiesUploaded}
                    enabled={true}
                  />
                </div>
              )}
            </div>
            <div className="row d-none d-lg-flex">
              <div className="col-lg-9">
                {person.additionalInfo.workingOrVolunteeringAsNP && (
                  <div className="w-55 inline-block">
                    <div>
                      Are you currently working or volunteering as an NP?
                    </div>
                    <div className="registration-info">
                      {person.additionalInfo.workingOrVolunteeringAsNP}
                    </div>
                  </div>
                )}
                {person.additionalInfo.nonNPJobProfession &&
                  person.additionalInfo.nonNPJobProfession !== "Select One" && (
                    <div className="w-15 inline-block">
                      <div>Working As:</div>
                      <div className="registration-info">
                        {person.additionalInfo.nonNPJobProfession}
                      </div>
                    </div>
                  )}
              </div>
              <div className="col-lg-3">
                {checkout.showSubmitProofOfStudies && (
                  <ProofOfStudiesUpload
                    onUploaded={this._proofOfStudiesUploaded}
                    enabled={true}
                  />
                )}
              </div>
            </div>
          </Box> */}

          <Box title="Registrant Information">
            <div className="d-lg-none">
              {me.event.conferenceType === "HealthPolicy" && (
                <div className="registration-info-item">
                  <div>National Provider Identifier</div> 
                    <div className="registration-info">
                      {person.npi
                        ? person.npi
                        : "N/A"}
                    </div>   
                  <div className="divider" />
                </div>
              )}

              {me.event.conferenceType !== "HealthPolicy" && (
                <div className="registration-info-item">
                  <div>National Provider Identifier</div> 
                    <div className="registration-info">
                      {person.additionalInfo.npiNumber
                        ? person.additionalInfo.npiNumber
                        : "N/A"}
                    </div>   
                  <div className="divider" />
                </div>
              )}
              {me.event.conferenceType !== "HealthPolicy" && person.additionalInfo.workingOrVolunteeringAsNP && (
                <div className="">
                  <div>Are you currently working or volunteering as an NP?</div>
                  <div className="registration-info">
                    {person.additionalInfo.workingOrVolunteeringAsNP}
                  </div>
                  <div className="divider" />
                </div>
              )}
              {me.event.conferenceType !== "HealthPolicy" && person.additionalInfo.nonNPJobProfession &&
                person.additionalInfo.nonNPJobProfession !== "Select One" && (
                  <div className="">
                    <div>Working as:</div>
                    <div className="registration-info">
                      {person.additionalInfo.nonNPJobProfession}
                    </div>
                    <div className="divider" />
                  </div>
                )}
                

              {checkout.showSubmitProofOfStudies && (
                <div>
                  <ProofOfStudiesUpload
                    onUploaded={this._proofOfStudiesUploaded}
                    enabled={true}
                  />
                </div>
              )}
            </div>
            <div className="row d-none d-lg-flex">
              <div className="col-lg-9">
                <div className="w-30 inline-block">
                  <div>National Provider Identifier</div>
                  {me.event.conferenceType === "HealthPolicy" && (
                  <div className="registration-info">
                    {person.npi
                      ? person.npi
                      : "N/A"}
                  </div>
                )}
                {me.event.conferenceType !== "HealthPolicy" && (
                  <div className="registration-info">
                    {person.additionalInfo.npiNumber
                      ? person.additionalInfo.npiNumber
                      : "N/A"}
                  </div>
                )}
                </div>
                {me.event.conferenceType !== "HealthPolicy" && person.additionalInfo.workingOrVolunteeringAsNP && (
                  <div className="w-55 inline-block">
                    <div>
                      Are you currently working or volunteering as an NP?
                    </div>
                    <div className="registration-info">
                      {person.additionalInfo.workingOrVolunteeringAsNP}
                    </div>
                  </div>
                )}
                {me.event.conferenceType !== "HealthPolicy" && person.additionalInfo.nonNPJobProfession &&
                  person.additionalInfo.nonNPJobProfession !== "Select One" && (
                    <div className="w-15 inline-block">
                      <div>Working As:</div>
                      <div className="registration-info">
                        {person.additionalInfo.nonNPJobProfession}
                      </div>
                    </div>
                  )}
              </div>
              <div className="col-lg-3">
                {checkout.showSubmitProofOfStudies && (
                  <ProofOfStudiesUpload
                    onUploaded={this._proofOfStudiesUploaded}
                    enabled={true}
                  />
                )}
              </div>
            </div>
          </Box>
          <Box title="Conference Fees">
            <div className="d-lg-none">
              {showJoinOrRenew && checkout.memberSavings > 0 && (
                <React.Fragment>
                  <button
                    className="btn btn-block btn-blue mb-3"
                    onClick={(e) => this._goToMembership()}
                  >
                    {isEligibleForRenewal
                      ? "Renew Your Membership"
                      : `Join & Save ${checkout.memberSavings.toFixed(2)}`}
                  </button>
                </React.Fragment>
              )}
              {conferenceFees.total >= 0 ? (
                <div className="row text-bold mb-2">
                  <div className="col-8">Total Due: </div>
                  <div className="col-4 text-right">
                    ${conferenceFees.total.toFixed(2)}
                  </div>
                </div>
              ) : (
                  <div className="row text-bold mb-2">
                    <div className="col-8">Credit Due: </div>
                    <div className="col-4 text-right">
                      ${conferenceFees.total.toFixed(2)}
                    </div>
                  </div>
                )}
              {conferenceFees.amountPaid > 0 && (
                <div className="row mb-2">
                  <div className="col-8">Total Paid:</div>
                  <div className="col-4 text-right">
                    ${conferenceFees.amountPaid.toFixed(2)}
                  </div>
                </div>
              )}
              <div className="text-bold mb-1">Fee Summary:</div>
              {conferenceFees.membershipFee && (
                <div className="row">
                        {conferenceFees.membershipFee.memberTypeName.includes("Post Master") ?
                        (
                          <div className="col-8">
                          Licensed NP Student Member Fee:
                          </div>
                        ) :
                        (
                          <div className="col-8">
                          {conferenceFees.membershipFee.memberTypeName} Fee:
                          </div>
                        )}
                  <div className="col-4 text-right">
                    ${conferenceFees.membershipFee.price.toFixed(2)}
                  </div>
                </div>
              )}
              {conferenceFees.eventFee > 0 && (
                <div className="row">
                  <div className="col-8">
                    {conferenceFees.eventFeeDescription}:
                  </div>
                  <div className="col-4 text-right">
                    ${conferenceFees.eventFee.toFixed(2)}
                  </div>
                </div>
              )}
              {conferenceFees.totalWorkshopFees > 0 && (
                <div className="row">
                  <div className="col-8">Workshop Fee(s):</div>
                  <div className="col-4 text-right">
                    ${conferenceFees.totalWorkshopFees.toFixed(2)}
                  </div>
                </div>
              )}
              {conferenceFees.spgFee !== null && (
                <div className="row">
                  <div className="col-8">SPG Fee:</div>
                  <div className="col-4 text-right">
                    ${conferenceFees.spgFee.amount.toFixed(2)}
                  </div>
                </div>
              )}
              {((conferenceFees.staffCredits &&
                conferenceFees.staffCredits.length > 0) ||
                conferenceFees.eventDiscount ||
                conferenceFees.promoCode ||
                (checkout.memberSavings > 0 &&
                  joinRenewMembershipType !== "")) && (
                  <div className="text-bold mb-1 mt-3">Discounts & Waivers:</div>
                )}
              {conferenceFees.promoCode && (
                <div className="row pb-1">
                  <div className="col-8">Promotional Code:</div>
                  <div className="col-4 text-right">
                    {conferenceFees.promoCode}
                  </div>
                </div>
              )}
              {conferenceFees.staffCredits.map((item) => (
                <div className="row">
                  <div className="col-8">{item.reason}:</div>
                  <div className="col-4 text-right red-text">
                    {item.amount.toFixed(2)}
                  </div>
                </div>
              ))}
              {/* KM: 2022 National */}
              {conferenceFees.eventDiscountTotal > 0 && (
                <div className="row">
                  <div className="col-8">Event Discount:</div>
                  <div className="col-4 text-right red-text">
                    -${conferenceFees.eventDiscountTotal.toFixed(2)}
                  </div>
                </div>
              )}
              {checkout.memberSavings > 0 &&
                joinRenewMembershipType !== "" &&
                false && (
                  <div className="row">
                    <div className="col-8">Member Discount:</div>
                    <div className="col-4 text-right red-text">
                      -${checkout.memberSavings.toFixed(2)}
                    </div>
                  </div>
                )}
              <div className="row mt-3 d-none">
                <div className="col-8">
                  <input type="text" placeholder="Promotional Code" />
                </div>
                <div className="col-4 text-right">
                  <button
                    className="btn btn-block btn-primary"
                    disabled="disabled"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div className="row d-none d-lg-flex">
              <div className="col-md-7 fees">
                <div className="row">
                  <div className="col-md-8">
                    <div className="row mb-3">
                      <div className="col-md-7">
                        <div className="fee-header">Fee Summary:</div>
                      </div>
                    </div>
                    {conferenceFees.membershipFee && (
                      <div className="row fees-item">                        
                      {conferenceFees.membershipFee.memberTypeName.includes("Post Master") ?
                        (
                          <div className="col-7 pb-1">
                          Licensed NP Student Member Fee:
                          </div>
                        ) :
                        (
                          <div className="col-7 pb-1">
                          {conferenceFees.membershipFee.memberTypeName} Fee:
                          </div>
                        )}
                        <div className="col-5 fee-amount">
                          ${conferenceFees.membershipFee.price.toFixed(2)}
                        </div>
                      </div>
                    )}
                    <div className="row fees-item">
                      <div className="col-7 pb-1">
                        <div>{conferenceFees.eventFeeDescription}:</div>
                      </div>
                      <div className="col-5 fee-amount">
                        <div>${conferenceFees.eventFee.toFixed(2)}</div>
                      </div>
                    </div>
                    {conferenceFees.totalWorkshopFees > 0 && (
                      <div className="row fees-item">
                        <div className="col-7 pb-1">
                          <div>Workshop Fee(s):</div>
                        </div>
                        <div className="col-5 fee-amount">
                          <div>
                            ${conferenceFees.totalWorkshopFees.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    )}
                    {conferenceFees.additionalFees.map((item, index) => (
                      <div className="row fees-item" key={index}>
                        <div className="col-7 pb-1">{item.feeType}:</div>
                        <div className="col-5 fee-amount">
                          ${item.amount.toFixed(2)}
                        </div>
                      </div>
                    ))}
                    {conferenceFees.promoCode && (
                      <div className="row fees-item">
                        <div className="col-7 pb-1">Promotional Code:</div>
                        <div className="col-5 fee-amount">
                          {conferenceFees.promoCode}
                        </div>
                      </div>
                    )}
                    {conferenceFees.staffCredits.map((item, index) => (
                      <div className="row fees-item" key={index}>
                        <div className="col-7 pb-1">{item.reason}:</div>
                        <div className="col-5 fee-amount red-text">
                          ${item.amount.toFixed(2)}
                        </div>
                      </div>
                    ))}
                    {/* KM: 2022 National */}
                    {conferenceFees.eventDiscountTotal > 0 && (
                      <div className="row fees-item">
                        <div className="col-7 pb-1">Event Discount:</div>
                        <div className="col-5 fee-amount red-text">
                          -${conferenceFees.eventDiscountTotal.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {checkout.memberSavings > 0 &&
                      joinRenewMembershipType !== "" &&
                      false && (
                        <div className="row">
                          <div className="col-7 pb-1">Member Discount:</div>
                          <div className="col-5 fee-amount red-text">
                            -${checkout.memberSavings.toFixed(2)}
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="col-lg-4">
                    <div className="row mb-3">
                      <div className="fee-header">Total:</div>
                    </div>
                    <div className="row">
                      <div className="fee-total">
                        ${conferenceFees.total.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                {showJoinOrRenew && checkout.memberSavings > 0 && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          className="btn btn-blue float-right w-60"
                          onClick={(e) => this._goToMembership()}
                        >
                          {isEligibleForRenewal
                            ? "Renew Your Membership"
                            : `Join & Save ${checkout.memberSavings.toFixed(
                              2
                            )}`}
                        </button>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                <div className="row d-none">
                  <div className="col-md-12">
                    <div className="pb-2">Promotional Code</div>
                    <input type="text" />
                  </div>
                </div>
              </div>
            </div>
            {!me.isRegistered &&
              checkout.memberSavings > 0 &&
              (checkout.person.isMember || joinRenewMembershipType !== "") && (
                <div
                  className="savings-text red-text"
                  style={{ display: "none" }}
                >
                  {true
                    ? `Your AANP Membership saved you $${
                    checkout.memberSavings
                    } today!`
                    : `You saved $${checkout.memberSavings} by joining today!`}
                </div>
              )}
          </Box>
          {showJoinOrRenew &&
            checkout.memberSavings > 0 &&
            checkout.membership !== null &&
            isNonMember && (
              <div className="info-box mt-4 col-lg-11 col-centered p-4">
                <MemberSavings
                  membership={checkout.membership}
                  me={me}
                  registrationMembershipType={
                    this.props.registrationMembershipType
                  }
                  headerText={
                    (isEligibleForRenewal ? "Renew" : "Join") + " Now and Save!"
                  }
                  showCta={false}
                />
                <button
                  className="btn btn-blue btn-join"
                  onClick={(e) => this._goToMembership()}
                >
                  {isEligibleForRenewal ? "Renew" : "Join"} Now
                </button>
              </div>
            )}
          {this._renderStaffPayment()}
          {this._totalDueOnCard() > 0 && (
            <Box title="Credit Card Information">
              <div className="row payment-info">
                <div className="col-lg-6 pr-lg-4 mb-4 mb-lg-0">
                  <div className="row mb-lg-3">
                    <div className="col-lg-6">
                      <label>First Name (On Card)</label>
                      <input
                        type="text"
                        name="firstName"
                        autoComplete="cc-given-name"
                        value={payment.firstName ? payment.firstName : ""}
                        className={
                          validation[input.firstName] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>Last Name (On Card)</label>
                      <input
                        type="text"
                        name="lastName"
                        autoComplete="cc-family-name"
                        className={
                          validation[input.lastName] ? errStrings.error : ""
                        }
                        value={payment.lastName ? payment.lastName : ""}
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-lg-4">
                      <label>Card Type</label>
                      <select
                        value={payment.cardType ? payment.cardType : ""}
                        name="cardType"
                        className={
                          validation[input.cardType] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      >
                        <option value="" />
                        <option value="AmEx">AMEX</option>
                        <option>MasterCard</option>
                        <option>Visa</option>
                        <option>Discover</option>
                      </select>
                    </div>
                    <div className="col-lg-8">
                      <label>Card Number</label>
                      <input
                        type="text"
                        name="cardNumber"
                        autoComplete="cc-number"
                        value={payment.cardNumber ? payment.cardNumber : ""}
                        maxLength={16}
                        className={
                          validation[input.cardNumber] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-lg-4">
                      <label>Exp. Month</label>
                      <select
                        value={payment.expMonth ? payment.expMonth : ""}
                        name="expMonth"
                        autoComplete="cc-exp-month"
                        className={
                          validation[input.expMonth] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      >
                        <option />
                        <option value="01">01</option>
                        <option value="02">02</option>
                        <option value="03">03</option>
                        <option value="04">04</option>
                        <option value="05">05</option>
                        <option value="06">06</option>
                        <option value="07">07</option>
                        <option value="08">08</option>
                        <option value="09">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <label>Exp. Year</label>
                      <select
                        value={payment.expYear ? payment.expYear : ""}
                        name="expYear"
                        onChange={this._updatePaymentInfo}
                        autoComplete="cc-exp-year"
                        className={
                          validation[input.expYear] ? errStrings.error : ""
                        }
                      >
                        <option />
                        {years.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <label>Security Code</label>
                      <input
                        type="text"
                        name="securityCode"
                        value={payment.securityCode ? payment.securityCode : ""}
                        autoComplete="cc-csc"
                        maxLength={4}
                        className={
                          validation[input.securityCode] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 billing-address pl-lg-4">
                  <div className="row pb-3 pl-2">
                    <div className="col-lg-12">
                      <div className="billing-address-header">
                        Billing Address
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <label>Country</label>
                    <select
                      ref={this.ref_contactCountry}                        
                      value={payment.country ? payment.country : ""}
                        name="country"
                        autoComplete="billing-country"
                        onChange={this._updatePaymentInfo}
                      className={validation[input.country] ? errStrings.error : ""}                        
                    >
                      <option value="">Please select one of the following</option>
                      {this.state.internationalCountries.map((country, key) => (
                            <option 
                              key={key} 
                              value={country.countryID}>{country.countryName}
                            </option>
                      ))}
                    </select>
                  </div>
                  <div className="row mb-lg-3 pt-1">
                    <div className="col-lg-6">
                      <label>Address Line 1</label>
                      <input
                        type="text"
                        name="street1"
                        autoComplete="billing address-line1"
                        value={payment.street1 ? payment.street1 : ""}
                        className={validation[input.street1] ? errStrings.error : ""}
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>Address Line 2</label>
                      <input
                        type="text"
                        name="street2"
                        autoComplete="billing address-line2"
                        value={payment.street2 ? payment.street2 : ""}
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  </div>
                  {this.state.showInternationalRegionTerritory && 
                    <div className="mb-2">
                      <label>Region / Territory</label>
                      <input
                        type="text"
                        name="county"
                        autoComplete="billing address-region"
                        value={ payment.county ? payment.county : "" }                        
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  }
                  <div className="row">
                    <div className="col-md-6">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        autoComplete="billing address-level2"
                        value={payment.city ? payment.city : ""}
                        className={
                          validation[input.city] ? errStrings.error : ""
                        }
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                    {this.state.showState && 
                      <div className="col-md-3">
                        <label>State</label>
                        <select
                          value={payment.state ? payment.state : ""}
                          name="state"
                          onChange={this._updatePaymentInfo}
                          autoComplete="billing address-level1"
                          className={
                            validation[input.state] ? errStrings.error : ""
                          }
                        >
                          <option value="">Please select a state</option>
                          {this.state.internationalStates.map((state, key) => (
                            <option 
                              key={key} 
                              value={state.stateAbbreviation}>{state.stateName}
                            </option>
                          ))}

                          {/* <option />
                          {checkout.states.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))} */}
                        </select>
                      </div>
                    }
                    <div className="col-md-3">
                      <label>Postal Code</label>
                      <input
                        ref={this.ref_contactPostalCode}
                        type="text"
                        name="zip"
                        autoComplete="billing postal-code"
                        className={
                          validation[input.zip] ? errStrings.error : ""
                        }
                        maxLength={5}
                        value={payment.zip ? payment.zip : ""}
                        onChange={this._updatePaymentInfo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          )}

          <Box
            title="Refund and Cancellation Policy"
            className="conference-information"
          >
            <div
              className="conference-description"
              dangerouslySetInnerHTML={{
                __html: checkout.cancellationAndRefundPolicy,
              }}
            />
          </Box>
          <div className="row mt-3">
            <div className="col-10 col-lg-5 col-centered">
              <LoadingButton
                text="Submit"
                loadingText="Processing your Payment, please wait..."
                isLoading={this.state.isLoading}
                onClick={this._submitPayment}
              />
            </div>
          </div>
          {checkoutResult !== null && !checkoutResult.success && (
            <div className="row checkout-error mt-3">
              {checkoutResult.reason === "Payment" && (
                <div className="col-10 col-lg-5 col-centered text-center">
                  An error occurred during the processing of your payment
                </div>
              )}
              {checkoutResult.message && (
                <div className="col-10 col-lg-5 col-centered text-center">
                  {checkoutResult.message}
                </div>
              )}
            </div>
          )}
        </form>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
    registrationMembershipType: state.membership.registrationMembershipType,
    joinRenewMembershipType: state.membership.joinRenewMembershipType,
    registrationMethod: state.registration.registrationMethod,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    accountActions
  )(CheckoutPage)
);
